import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { ReviewAction } from '@euler/app/flows/apdm/imports/ReviewControls';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
/**
 * @file: GlobalMessageBody.tsx
 *
 * `OrgGlobalMessage` — org-wide announcement with optional thumbnail.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrgGlobalMessageFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import { MediaStrip } from '../MediaStrip';
import { BodyText, TitleText } from './common/primitives';

export const GlobalMessageBody: FC<{ p: OrgGlobalMessageFeedPayload }> = ({
  p,
}) => {
  const navigation = useAppNavigation();
  const profile = useUserProfileInfo();
  const { rpx } = useResponsiveContext();
  return (
    <View>
      <TitleText>{p.title}</TitleText>
      <BodyText mt={6}>{p.message}</BodyText>
      {p.apdmReport && p.apdmReport.storeId === profile?.store.id && (
        <ReviewAction
          title="查看活动报告"
          onPress={() =>
            navigation.navigate('ApdmCampaign', {
              campaignId: p.apdmReport!.campaignId,
              tab: 'analysis',
            })
          }
        />
      )}
      {p.thumbnail ? (
        <View style={{ marginTop: rpx(10) }}>
          <MediaStrip
            medias={[{ url: p.thumbnail }]}
            size={120}
            max={1}
            gap={0}
            previewable
          />
        </View>
      ) : null}
    </View>
  );
};
